<template>
  <div class="jijin-div">
        <div class="jijin">
			<!-- <div class="tab-box2">
				<div class="tab-item" style="border-right: 2px solid #E60011;justify-content: flex-start;" @click="changeMsgNew" :class="highLiang==0?'activeMsg':''">
					<img :src="img1ColorChange" alt="">项目
				</div>
				<div class="tab-item" style="justify-content: flex-end;" @click="changeMsgReport" :class="highLiang==1?'activeMsg':''">
					<img :src="img2ColorChange" alt="">基金
				</div>
			</div> -->
            <div class="jijin1" v-if="jijing[0]">
                <div class="box" @click="jumpto(0)">
                    <!--第一行(lineFirst)-->
                    <div class="lineF">
                        <div class="boxF">
                            <div class="boxS">
                                <div class="boxT">
                                    <div class="overlay">
                                        <img :src="jijing[0].smallImage" alt="">
                                        <h3>{{jijing[0].title}}</h3>  
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="jijin2" v-if="jijing[1]">
                <div class="box1" @click="jumpto(1)">
                    <!--第一行(lineFirst)-->
                    <div class="lineF">
                        <div class="boxF1">
                            <div class="boxS1">
                                <div class="boxT1">
                                    <div class="overlay1">
                                        <img :src="jijing[1].smallImage" alt="">
                                        <h3>{{jijing[1].title}}</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="jijin3" v-if="jijing[2]">
                <div class="box" @click="jumpto(2)">
                    <!--第一行(lineFirst)-->
                    <div class="lineF">
                        <div class="boxF">
                            <div class="boxS">
                                <div class="boxT">
                                    <div class="overlay">
                                        <img :src="jijing[2].smallImage" alt="">
                                        <h3>{{jijing[2].title}}</h3>  
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="jijin4" v-if="jijing[3]">
                <div class="box"  @click="jumpto(3)">
                    <!--第一行(lineFirst)-->
                    <div class="lineF">
                        <div class="boxF">
                            <div class="boxS">
                                <div class="boxT">
                                    <div class="overlay">
                                        <img :src="jijing[3].smallImage" alt="">
                                        <h3>{{jijing[3].title}}</h3>  
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="jijin5" v-if="jijing[4]">
                <div class="box" @click="jumpto(4)">
                    <!--第一行(lineFirst)-->
                    <div class="lineF">
                        <div class="boxF">
                            <div class="boxS">
                                <div class="boxT">
                                    <div class="overlay">
                                        <img :src="jijing[4].smallImage" alt="">
                                        <h3>{{jijing[4].title}}</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="jijin6" v-if="jijing[5]">
               <div class="box" @click="jumpto(5)">
                    <!--第一行(lineFirst)-->
                    <div class="lineF">
                        <div class="boxF">
                            <div class="boxS">
                                <div class="boxT">
                                    <div class="overlay">
                                        <img :src="jijing[5].smallImage" alt="">
                                        <h3>{{jijing[5].title}}</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="jijin7" v-if="jijing[6]">
                <div class="box" @click="jumpto(6)">
                    <!--第一行(lineFirst)-->
                    <div class="lineF">
                        <div class="boxF">
                            <div class="boxS">
                                <div class="boxT">
                                    <div class="overlay">
                                        <img :src="jijing[6].smallImage" alt="">
                                        <h3>{{jijing[6].title}}</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="jijin8" v-if="jijing[7]">
                <div class="box" @click="jumpto(7)">
                    <!--第一行(lineFirst)-->
                    <div class="lineF">
                        <div class="boxF">
                            <div class="boxS">
                                <div class="boxT">
                                    <div class="overlay">
                                        <img :src="jijing[7].smallImage" alt="">
                                        <h3>{{jijing[7].title}}</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="jijin-more" style="cursor: pointer;" @click="jump">
                <span>[查看更多]</span>
            </div>
        </div>
    </div>
</template>

<script>
import apiUrls from "@api";
export default {
  data () {
    return {
        jijing:[],
		highLiang: 0,
		img1ColorChange:  require('../assets/img/hoszhi00.png'),
		img2ColorChange:  require('../assets/img/hoszhi00.png'),
    };
  },

  components: {

  },


  mounted(){
	  this.img1ColorChange = require('../assets/img/hoszhi.png')
      this.getXiangmu()
  },

  methods: {
	  changeMsgNew() {
	  	this.highLiang = 0
		this.getXiangmu()
	  	this.img1ColorChange = require('../assets/img/hoszhi.png')
	  	this.img2ColorChange = require('../assets/img/hoszhi00.png')
	  },
	  changeMsgReport() {
	  	this.highLiang = 1
		this.getJijin()
	  	this.img2ColorChange = require('../assets/img/hoszhi.png')
	  	this.img1ColorChange = require('../assets/img/hoszhi00.png')
	  },
	  jump() {
		if(this.highLiang == 0){
			this.$router.push('projectIntro')
		}else {
			this.$router.push('fundIntrduce')
		}  
	  },
	  jumpto(index){
		  window.open(this.jijing[index].link, "_blank");
		  /* if(this.highLiang == 0){
		  	this.$router.push({path:'proDetail', query:{id: this.jijing[index].id}})
		  }else {
		  	this.$router.push({path:'fundDetail', query:{id: this.jijing[index].id}})
		  }  */
	  },
        //项目
		getXiangmu() {
			apiUrls.getList({ node: 'xmyjj' }).then(res => {
				this.jijing = res.results.data;
			});
		},
		
		/* getJijin() {
			apiUrls.getList({ node: 'jjjs' }).then(res => {
				this.jijing = res.results.data;
			});
		}, */
  }
}

</script>
<style lang="less">
		
 body, div, img, ul, li
        {
            margin: 0;
            padding: 0;
        }
        body
        {
            font-size: 12px;
            background-color: #DDD;
            min-width: 1200px;
        }
        ul, ul li
        {
            list-style: none;
        }
        .clear
        {
            clear: both;
        }       
        .box
        {
            position: relative;
        }
        .lineF, .lineS
        {
            position: absolute;
            visibility: hidden;
        }
        .lineS
        {
            top: 182px;
            left: 105px;
        }
        .boxF, .boxS, .boxT, .overlay
        {
            width: 278px;
            height: 241px;
            overflow: hidden;
        }
        .boxF1, .boxS1, .boxT1, .overlay1
        {
            width: 391px;
            height: 339px;
            overflow: hidden;
        }
        .boxF, .boxS
        {
            visibility: hidden;
        }
        .boxF1, .boxS1
        {
            visibility: hidden;
        }
        .boxF
        {
            transform: rotate(120deg);
            float: left;
            margin-left: 10px;
            -ms-transform: rotate(120deg);
            -moz-transform: rotate(120deg);
            -webkit-transform: rotate(120deg);
        }
        .boxF1
        {
            transform: rotate(120deg);
            float: left;
            margin-left: 10px;
            -ms-transform: rotate(120deg);
            -moz-transform: rotate(120deg);
            -webkit-transform: rotate(120deg);
        }
        .boxS
        {
            transform: rotate(-60deg);
            -ms-transform: rotate(-60deg);
            -moz-transform: rotate(-60deg);
            -webkit-transform: rotate(-60deg);
        }
        .boxS1
        {
            transform: rotate(-60deg);
            -ms-transform: rotate(-60deg);
            -moz-transform: rotate(-60deg);
            -webkit-transform: rotate(-60deg);
        }
        .boxT
        {
            transform: rotate(-60deg);
            background: no-repeat 50% center;
            background-size: 200% auto;
            -ms-transform: rotate(-60deg);
            -moz-transform: rotate(-60deg);
            -webkit-transform: rotate(-60deg);
            visibility: visible;
            cursor: pointer;
        }
        .boxT1
        {
            transform: rotate(-60deg);
            background: no-repeat 50% center;
            background-size: 200% auto;
            -ms-transform: rotate(-60deg);
            -moz-transform: rotate(-60deg);
            -webkit-transform: rotate(-60deg);
            visibility: visible;
            cursor: pointer;
        }
        .overlay
        {
            transition: all 250ms ease-in-out 0s;
            position: relative;
        }
         .overlay1
        {
            transition: all 250ms ease-in-out 0s;
            position: relative;
        }
        .overlay img{
            width: 100%;
            height: 100%;
        }
        .overlay:hover
        {
            background-color: rgba(0,0,0,0.6);
        }
        .boxT:hover .overlay
        {
            transform: scale(1.1);
        }
        .overlay1 img{
            width: 100%;
            height: 100%;
        }
        .overlay1:hover
        {
            background-color: rgba(0,0,0,0.6);
        }
        .boxT1:hover .overlay1
        {
            transform: scale(1.1);
        }
        .box h3 {
            position: absolute;
            top: 105px;
            left: 80px;
            width: 100%;
            height: 30px;
            padding-bottom: 2%;
            // border-bottom:1px solid white;
            font-size: 18px;
            font-weight: bold;
            line-height: 30px;
            transition:transform .35s;
            transform:translate3d(0,20px,0);
            opacity:0;
            font-family: MicrosoftYaHeiUI-Bold, MicrosoftYaHeiUI;
            color:#FFFFFF;
        }
        .box:hover h3 {
            transform:translate3d(0,0,0);
            opacity:1;
        }
        .box1 h3 {
            position: absolute;
            top: 160px;
            left: 120px;
            width: 100%;
            height: 30px;
            padding-bottom: 2%;
            // border-bottom:1px solid white;
            font-size: 18px;
            font-weight: bold;
            line-height: 30px;
            transition:transform .35s;
            transform:translate3d(0,20px,0);
            opacity:0;
            font-family: MicrosoftYaHeiUI-Bold, MicrosoftYaHeiUI;
            color:#FFFFFF;
        }
        .box1:hover h3 {
            transform:translate3d(0,0,0);
            opacity:1;
        }

.jijin-div {
	width: 100%;
	height: 687px;
	background-image: url('../assets/img/xiangmujjbeijing.png');
	display: flex;
	justify-content: center;
	align-content: center;
}
.jijin{
  width: 1200px;
  // background-color: #df9161;
  position: relative;
  overflow: hidden;
}
.tab-box2 {
		padding-left: 5px;
		height: 40px;
		font-size: 20px;
		font-family: "microsoft yahei";
		color: #777777;
		display: flex;
		align-items: flex-start;
		justify-content: flex-start;
		position: absolute;
		left: 400px;
		top: 20px;
		.tab-item {
			width: 110px;
			height: 20px;
			display: flex;
			align-items: center;
			cursor: pointer;
			img {
				margin-right: 5px;
				height: 15px;
				width: 15px;
			}
		}
		.activeMsg {
			color: #C11818;
		}
	}

.jijin1{
  position: absolute;
  top: 4px;
  left: 2px;
  width: 278px;
  height: 241px;
}
.jijin2 {
	position: absolute;
	top: 195px;
	left: 145px;
	width: 518px;
	height: 518px;
}
.jijin3 {
	position: absolute;
	top: 115px;
	left: 465px;
	width: 363px;
	height: 363px;
}
.jijin4 {
	position: absolute;
	top: 370px;
	left: 470px;
	width: 363px;
	height: 363px;
}
.jijin5 {
	position: absolute;
	top: 245px;
	left: 685px;
	width: 363px;
	height: 363px;
}
.jijin6 {
	position: absolute;
	top: 0px;
	left: 685px;
	width: 363px;
	height: 363px;
}
.jijin7 {
	position: absolute;
	top: 120px;
	left: 900px;
	width: 363px;
	height: 363px;
}
.jijin8 {
	position: absolute;
	top: 380px;
	left: 900px;
	width: 363px;
	height: 363px;
}
.jijin-more {
	position: absolute;
	top: 610px;
	left: 10px;
	width: 75px;
}
.jijin-more span {
	width: 75px;
	height: 20px;
	font-size: 16px;
	font-family: MicrosoftYaHeiUI;
	color: #c11818;
	line-height: 20px;
}
</style>